import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setOrigemCollection = async (context, search) => {
  const body = { active: true, search };
  const { data } = await api().post('fiscal.get-origem_produto', body);
  const origemCollection = data.map((e) => ({ ...e, text: e.descricao, value: e }));
  context.commit(types.SET_ORIGEM_COLLECTION, origemCollection);
};
